var moment = require('moment-timezone');

export function toTimeZone(time, zone) {
    var format = "DD/MM/YYYY h:mm A z(Z)";
    return moment(time).tz(zone).format(format);
}